export default function scrollToSection(id, scale = 1) {
    if (!id) return;
    const scrollableRegion = document.getElementById("document-report");
    const element = document.getElementById(`${id}`);
    if (element) {
        const offsetTop = element.offsetTop * scale; // multiply by the document scale factor
        if (scrollableRegion) {
            scrollableRegion.scrollTo({
                top: offsetTop,
                behavior: "smooth"
            });
        } else {
            window.scrollTo({
                top: offsetTop,
                behavior: "smooth"
            });
        }
    }
}
